export default __webpack_public_path__ + "static/banner-media-release-oct2-0604303df662403f0569d690e8cfaa3a.jpg";